/**
 * OceRead 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * OceRead 品牌特定主题配置
 * 注意: 大部分颜色应使用 UnoCSS 主题变量,这里只保留品牌特有的配置
 */
export const theme = {
  // 引用装饰线颜色 (OceRead 使用蓝色调,基于主色 #6B92FD)
  quoteColor: 'rgba(107, 146, 253, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
